import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Tracking from './Pincodefinder/Tracking';
import RajAirTracking from './Pincodefinder/RajAirTracking';
import JaimarutiTraking from './Pincodefinder/JaimarutiTraking';
import JdcargoTracking from './Pincodefinder/Track';
import SendMailFrontend from './Pincodefinder/SendMailFrontend';
import Track from './Pincodefinder/Track';
import AsTracking from './Pincodefinder/AsTracking';
import BsWorldwideTracking from './Pincodefinder/BsWorldwideTracking';
import VndrRateSearchonline from './Pincodefinder/VndrRateSearchonline';
import DocketWiseKycUpload from './Pincodefinder/DocketWiseKycUpload';
import DocketWiseKyc from './Pincodefinder/DocketWiseKyc';
import FastMovTracking from './Pincodefinder/FastMovTracking';



// import Pincode from './Pincodefinder/Pincode';


function App() {
  return (
    <Router>
      <div>
        {/* Other components */}
        <Routes>
          {/* Define routes for Pincode and Tracking */}
          {/* <Route path="/pincode" element={<Pincode />} /> */}
          <Route path="/tracking" element={<Tracking />} />
            <Route path="/VndrRateSearchonline" element={<VndrRateSearchonline />} /> 
            <Route path="/AsTracking" element={<AsTracking />} />
             <Route path="/BsWorldwideTracking" element={<BsWorldwideTracking />} /> 
             <Route path="/FastMovTracking" element={<FastMovTracking />} /> 
             <Route path="/DocketWiseKyc" element={<DocketWiseKyc />} /> 
            <Route path="/RajAirTracking" element={<RajAirTracking />} /> 
          <Route path="/DocketWiseKycUpload" element={<DocketWiseKycUpload />} />
          <Route path="/Track" element={<Track />} />
           <Route path="/SendMailFrontend" element={<SendMailFrontend />} />
          <Route path="/JaimarutiTraking" element={<JaimarutiTraking />} />
                {/* <Route path="/tracking" element={<Progresss />} /> */}
        </Routes>
        {/* Other components */}
      </div>
    </Router>
  );
}

export default App;
